import React, { useState } from "react"

import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import { Button } from "~tailwindui/Basics"
import WithLoadingIndicator from "~tailwindui/Basics/WithLoadingIndicator"
import Table from "~tailwindui/Table/Table"

import Header from "components/OrganizationAdmin/components/DisplayableFormikForm/Header"

const UsersPage = () => {
  const history = useHistory()

  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: organizationAdminsQuery,
    variables: { page },
  })

  if (
    result.data &&
    !result.data.viewer.canOrganizationAdminAccessUserManagement
  ) {
    return <span>Sorry, you don't have access to this page.</span>
  }
  return (
    <WithLoadingIndicator result={result} header={<Header title="Users" />}>
      {({ data }) => (
        <>
          <Table
            title={
              <>
                <Button
                  text="New User"
                  className="ml-4"
                  onClick={() => history.push("/users/new")}
                />
              </>
            }
            data={data.viewer.organization.organizationAdmins}
            changePage={setPage}
            rowCallback={user => history.push(`/users/${user.id}`)}
            cols={[
              { header: "Name", value: user => user.fullName },
              { header: "Email", value: user => user.email },
              { header: "Username", value: user => user.username },
              { header: "Phone", value: user => user.phoneNumber },
            ]}
          />
        </>
      )}
    </WithLoadingIndicator>
  )
}

const organizationAdminsQuery = gql`
  query organizationAdmins($page: Int!) {
    viewer {
      canOrganizationAdminAccessUserManagement
      organization {
        organizationAdmins: paginatedOrganizationAdmins(page: $page) {
          currentPage
          totalPages
          data {
            id
            fullName
            username
            email
            phoneNumber
          }
        }
      }
    }
  }
`

export default UsersPage
